import React from 'react';

const Categories = () => (
  <div>
    Hello site under construction!
  </div>
);

export default Categories;
